export default __webpack_public_path__ + "static/media/circleArrow.7cb1b4c4.svg";